import React, { useEffect, useRef } from 'react';
import { styled } from "@mui/system";

const StyledPdfContainer = styled('div')(({ theme }) => ({
    "position": 'fixed',
    "top": '50%',
    "left": '50%',
    "transform": 'translate(-50%, -50%)',
    "width": '70%',
    "height": '85%',
    "zIndex": 9999,
    "display": 'flex',
    "justifyContent": 'center',
    "alignItems": 'center',

    '& object': {
        width: '100%',
        height: '100%',

    },
}));

const Overlay = styled('div')(({ theme }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.backdrop,
    zIndex: 9998,
}));

const PdfViewer = ({ open, pdfData, onClose }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                onClose();
            }
        };

        const handlePdfLoad = () => {
            document.addEventListener('click', handleClickOutside);
        };

        if (open) {
            const objNode = document.createElement("object");
            objNode.setAttribute("type", "application/pdf");
            objNode.setAttribute("data", pdfData);
            objNode.addEventListener('load', handlePdfLoad);

            const container = document.getElementById("pdfContainer");
            container.innerHTML = '';

            container.appendChild(objNode);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [open, pdfData, onClose]);

    return (
        <>
            {open && (
                <>
                    <StyledPdfContainer ref={containerRef} id="pdfContainer" />
                    <Overlay />
                </>
            )}
        </>
    );
};

export default PdfViewer;
